// Whether the client should *attempt* to restore a saved weed result, not
// whether the viewer may read it. The result route authorizes an authenticated
// owner without a token, so an owner arriving from /result/[id] has an
// analysis id and no `access` param. Authorization stays server-side; a denied
// attempt falls through to a fresh scan.
export function shouldRestoreSignedWeedResult({
  analysisId,
  hasResult,
  refinementOfAnalysisId,
}: {
  analysisId: string | null
  accessToken?: string | null
  hasResult: boolean
  refinementOfAnalysisId: string | null
}): boolean {
  return Boolean(analysisId && !hasResult && !refinementOfAnalysisId)
}
